import { render } from "./App.vue?vue&type=template&id=abd6bc80"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=abd6bc80&lang=css"

import exportComponent from "../../../kaicms_vue_250623/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__